// For some reason Window interface fails to inject when running ng build --prod, see: https://github.com/angular/angular/issues/12631
// Solution was to create a dummy class extending the window interface
export class WindowWrapper extends Window {}
